<template>

<v-app style="background-color: transparent">
 
    <PasswordReset v-if="showPasswordReset" @close="togglePasswordReset()"></PasswordReset>

    <v-container fill-height style="max-width:500px; width:auto;">
    
      <v-card :class="{ 'signup-form': !showLoginForm }" style="background-color:transparent" class="elevation-0">

        <v-form v-if="showLoginForm" @submit.prevent>

          <!-- <v-card-title class="display-3 text-sm-h1 white--text font-weight-bold pt-0 pb-0">Welcome</v-card-title>

          <v-card-title class="display-3 text-sm-h1 white--text font-weight-bold pt-0">Back.</v-card-title> -->

          <v-card-text>
          
            <v-card-text class="white--text pl-0 pt-0">Password</v-card-text>
            
            <v-text-field solo v-model.trim="passwordForm.password" label="password" type="password" placeholder="●●●●●●●" id="password1" :rules="passwordRules" required class="body-2 grey--text text--darken-1"/>

            <v-card-text class="white--text pl-0 pt-0">Confirm Password</v-card-text>
            
            <v-text-field solo v-model.trim="passwordForm.confirm" label="confirm password" type="password" placeholder="●●●●●●●" id="password1" :rules="confirmPasswordRules" required class="body-2 grey--text text--darken-1"/>
          
            <v-card-actions class="pa-0">

              <v-btn color="primary" class="font-weight-medium" @click="setPassword()" style="height:50px">Set Password</v-btn>

              <!-- <v-spacer></v-spacer>

              <v-btn color="white" class="font-weight-medium" text @click="togglePasswordReset()" >Forgot Password</v-btn> -->
        
            </v-card-actions>

        </v-card-text>
        
        </v-form>

      </v-card>

    </v-container>

</v-app>

</template>


<script>
import PasswordReset from '@/components/PasswordReset'

export default {
  components: {
    PasswordReset
  },
  data() {
    return {
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: ''
      },
      passwordForm: {
        password: '',
        confirm: ''
      },
      showLoginForm: true,
      showPasswordReset: false,

      validPassword: '',
      passwordRules:[
        (value) => !!value || "Please type password",
        (value) => (value && value.length >= 6) || "minimum 6 characters",
        ],
        confirmPasswordRules: [
          (value => !!value || "type confirm password"),
          (value) => value === this.passwordForm.password || "The password confirmation does not match",
        ],
    }
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset
    },
    setPassword() {

      var newPassword = String(this.passwordForm.password)

      this.$store.dispatch('setPassword', {
        password:this.passwordForm.password
      })
    
    }
  }
}
</script>
